import { config } from '../../config'
import { get as getCookie } from '../../cookies'
import { isInternal } from '../../internalUser'
import { sendFbEvent } from '../facebook'
import { GA_EVENT_TYPE } from '../../../components/shared/sections/my-account/utils';
import { useSelector } from 'react-redux';

declare const window: any;

export const logGaEvent = (metaData: any) => {
    if (navigator.cookieEnabled && window?.localStorage?.getItem('enableGaLogging') === 'true') {
        console.log('GA Event logged:- ', metaData);
    }
}
export const generateEventId =  () => "event.id_" + Math.round(Date.now()) + "_" + Math.round(Math.random() * 1000);

export const sendGaEvent = (metaData: any) => {
    logGaEvent(metaData);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(metaData);
};

export const errorTrackingGaEvent = (pageType: string = '', errorDescription: string = '') => {
    const metaData = {
        event: 'errors',
        pageType: pageType,
        errorDescription: errorDescription
    };
    logGaEvent(metaData);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(metaData);
};

export const loqateGAEvents = (addressField: string = '', actionType: string = '') => {
    const metaData = {
        event: 'locate_address',
        addressField: addressField,
        actionType: actionType
    };
    logGaEvent(metaData);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(metaData);
};

export const newsletterEvent = function (location: string = '') {
    const metaData = {
        event: 'signup_newsletter',
        signup_location: location
    };

    sendGaEvent(metaData);
};

export const applyPromoEvent = function (payload) {
    const { coupon, event_value } = payload;
    const metaData = {
        event: 'promo_apply',
        coupon_name: coupon,
        event_value: event_value
    };

    sendGaEvent(metaData);
};

export const cartInteractionEvent = function (label,prod_class?) {
    const metaData: any = {
        event: 'cart_interaction',
        label: label,
    };
    if(prod_class){
        metaData.prod_class = prod_class;
    }
    sendGaEvent(metaData);
};

export const checkoutInteractionEvent = function (event,label,prod_class?) {
    const metaData: any = {
        event: event,
        label: label,
    };
    if(prod_class){
        metaData.prod_class = prod_class;
    }
    sendGaEvent(metaData);
};

export let datalayerEvent = ( currentPage ) => {

    let metaData = {
        event: "dataLayer_initialize",
        user_id: getCookie("np.ct.user") ? getCookie("np.ct.user") : getCookie("np.anonymousId"),
        np_user: getCookie("fake") === "true" ? true : false,
        login: getCookie("np.ct.user") ? true : false,
        consent: getCookie("cookieConsent") === "true" ? true : false,
        ftb: getCookie("UserType") === "ftb" ? 1 : 0,
        country: config("regionCode") || '',
        language: config("language") || '',
        currency: config("currency") || '',
        page_type: currentPage,
        web_traffic_type: "external"
    }

    if (!metaData.user_id) {
        metaData.user_id = window.user_id;
    }

    if (isInternal()) {
        metaData.web_traffic_type = "internal";
    }
    const fbMetaData = { event_name: 'PageView' };
    logGaEvent(metaData);
    sendFbEvent(fbMetaData, currentPage);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(metaData);
};

export const FunctionalityTrackingGaEvent = (event: GA_EVENT_TYPE , label: string = '', value: string = '') => {
    let metaData: any = {
        event: event,
        label: label
    }

    if(value !== '') {
        metaData.value = value;
    }

    sendGaEvent(metaData);
};

export const breadcrumbGaEvent=( page_type: string = '', label: string = '')=>{
    const metaData = {
        event: 'breadcrumb',
        label: label,
        page_type: page_type
    };
    sendGaEvent(metaData);
}

export const ActionGaEvent = (event: GA_EVENT_TYPE , action: string = '', label: string = '', value: string = '') => {
    const metaData = {
        event: event,
        action: action,
        label: label,
        value: value
    };

    sendGaEvent(metaData);
};

export const uploadArtworkGaEvent = (page) => {
    const metaData = {
      event: 'upload_artwork',
      page_name: page
    };
    sendGaEvent(metaData);
}

export const DNSTrackGAEvent = (user_action) => {
    const metaData = {
        event: 'dns_form',
        user_action: user_action
    };
    sendGaEvent(metaData);
}
 
export const DNSTrackErrorGAEvent = (pageType, errorDescription) => {
    const metaData = {
        event: 'errors',
        pageType: pageType,
        errorDescription: errorDescription
    };
    sendGaEvent(metaData);
}
export const sendProductClickGAEvent = (lineItem, listId) =>{
    const { productFamilyName, productName, categoryName } = lineItem;
  
    const gaObject = {
      event: "product_click",
      listId: `${listId}`,
      position: "-1",
      products: [{
        listId: `${listId}`,
        position: "-1",
        class: productFamilyName,
        name: productName,
        category: categoryName,
        product_type: productFamilyName ? ((productFamilyName.slice(0,3) === 'VEN' || productFamilyName.slice(0,3) === 'VDS') ? 'vendor' : 'inhouse') : '',
      }]
    };
    sendGaEvent(gaObject);
  }

